import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { FunctionComponent } from 'react';
import { OptionalFormattedDate } from '../OptionalFormattedDate';
import { FormattedMessage } from 'react-intl';
import { CustomsInformation } from '../common.types';
import { NoValue } from '../NoValue';

export type CustomsInformationExpanderProps = {
    customsInformation?: CustomsInformation | undefined;
};

export const CustomsInformationExpander: FunctionComponent<CustomsInformationExpanderProps> = ({
    customsInformation,
}) => {
    const title = (
        <>
            <span className="rioglyph rioglyph-border-crossing text-size-18 margin-right-5" />
            <FormattedMessage id="outboundOrderBook.common.sidebar.details.vehicle.customsInformation" />
        </>
    );

    return (
        <ExpanderPanel title={title} bsStyle="default" className="margin-20">
            <table className="table table-row-first-border-none table-row-last-border-none table-layout-fixed">
                <tbody>
                    <tr>
                        <td>
                            <FormattedMessage id="outboundOrderBook.common.sidebar.details.vehicle.customsInformation.referenceNumber" />
                        </td>
                        <td className="ellipsis-1">{customsInformation?.customsReferenceNumber ?? <NoValue />}</td>
                    </tr>
                    <tr>
                        <td>
                            <FormattedMessage id="outboundOrderBook.common.sidebar.details.vehicle.customsInformation.issuedAt" />
                        </td>
                        <td>
                            <OptionalFormattedDate date={customsInformation?.customsReferenceNumberIssuedAt} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </ExpanderPanel>
    );
};
